// Runtime config. The app runs on mock data by default so `pnpm web:dev` works with no
// backend; set VITE_USE_API=true to go live. A live guest app figures out *which* event it
// is from its own URL — a ?event=<slug> query (dev), a <slug>.<root> subdomain, or, for a
// vanity domain, its bare hostname (resolved server-side).

export const USE_API = import.meta.env.VITE_USE_API === "true";

/** API base — same-origin "/api" in dev (Vite proxies to the Worker) and in prod. */
export const API_BASE = import.meta.env.VITE_API_BASE ?? "";

/** Platform root domain, e.g. "myphotos.app" — used to read the tenant from the subdomain. */
export const ROOT_DOMAIN = import.meta.env.VITE_ROOT_DOMAIN ?? "";

const NON_TENANT_LABELS = new Set(["app", "api", "www"]);

/** How this guest app should identify its event: by slug (query/subdomain) or by host. */
export type TenantRef = { kind: "slug"; slug: string } | { kind: "host"; host: string };

export function tenantRef(): TenantRef {
  const params = new URLSearchParams(window.location.search);
  const q = params.get("event");
  if (q) return { kind: "slug", slug: q };

  const host = window.location.hostname;
  if (ROOT_DOMAIN && host.endsWith(`.${ROOT_DOMAIN}`)) {
    const label = host.slice(0, -(ROOT_DOMAIN.length + 1));
    if (label && !NON_TENANT_LABELS.has(label)) return { kind: "slug", slug: label };
  }
  // A bare custom domain (or unknown host): let the server map it.
  return { kind: "host", host };
}
